module.exports = __webpack_public_path__ + "static/media/catipult.8361dea0.png";